export default class OnlineUserState {
  // The ID is just to make storing in the IndexedDB easier
  public id: string = '0';
  public lastUpdated: number = 0;
  public onlineUserIds: string[] = [];
}
